import getUploadUrl from './getUploadUrl';

const useGetUploadUrl = () => {
  return getUploadUrl;
};

export default useGetUploadUrl;
